module.exports = __webpack_public_path__ + "static/media/personal-info.cd579bae.png";